import React, { useEffect, useState } from "react";
import BreedMenuItem from "../../assets/json/Breeding.js";
import {  Layout, Menu, theme, Button } from "antd";
import { ReactComponent as SlideFalseIcon } from "../../assets/icon/收回.svg";
import { ReactComponent as SlideTrueIcon } from "../../assets/icon/展开.svg";
import styled from 'styled-components';
import storage from "../../utils/storage";
// import './breedmenu.css'
const { Sider } = Layout;
const CustomMenu = styled(Menu)`
  .ant-menu-item-selected {
    background-color: #E1E7D9 !important; /* 修改背景色 */
    color: #000 !important; /* 修改字体颜色 */
  }

  .ant-menu-item:hover {
    background-color: #E1E7D9 !important; /* 修改背景色 */
    color: #000 !important; /* 修改字体颜色 */
  }
`;
function BreedMenuComp() {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [BreedCurrent, setBreedCurrent] = useState(
    storage.getItem("BreedMenuKey")
     ||'left1'
  );
  const BreedClick = (e) => {
    storage.setItem("BreedMenuKey", e.key);
  };
  useEffect(()=>{
    setBreedCurrent(storage.getItem("BreedMenuKey"))
  },[storage.getItem("BreedMenuKey")])
  const [collapsed, setCollapsed] = useState(false);
  
  return (
    <Sider
      style={{
        background: colorBgContainer,
        position:"relative",
        fontWeight:"bold",
        height:"100%"

      }}
      width={240}
      collapsed={collapsed}
      onCollapse={setCollapsed}
      collapsedWidth={5}
    >
      <CustomMenu
        mode="inline"
        selectedKeys={[BreedCurrent]}
        onClick={BreedClick}
        style={{
          height: "100%",
        }}
        items={BreedMenuItem}
      />
        <Button
        ghost
        style={{
          width: "52px",
          heightL: "52px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border:"none",
          position:"absolute",
          top:"40%",
          right:"-30px",
          background:"transparent"
        }}
        onClick={()=>{
          setCollapsed(!collapsed);
        }}
      >
        {
          collapsed?<SlideTrueIcon width={25}/>:<SlideFalseIcon width={25} />
        }
      </Button>
    </Sider>
  );
}

export default BreedMenuComp;
